export default __webpack_public_path__ + "static/media/chatApp.54cb8d29.png";